import axios from 'axios';
import {
  DEPLOYMENT_SETTING_LOAD_PROJECT_DEP_SETTING_BEGIN,
  DEPLOYMENT_SETTING_LOAD_PROJECT_DEP_SETTING_SUCCESS,
  DEPLOYMENT_SETTING_LOAD_PROJECT_DEP_SETTING_FAILURE,
  DEPLOYMENT_SETTING_LOAD_PROJECT_DEP_SETTING_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function loadProjectDepSetting(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DEPLOYMENT_SETTING_LOAD_PROJECT_DEP_SETTING_BEGIN,
    });

    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/projects/${projectId}/`,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: DEPLOYMENT_SETTING_LOAD_PROJECT_DEP_SETTING_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: DEPLOYMENT_SETTING_LOAD_PROJECT_DEP_SETTING_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadProjectDepSettingError() {
  return {
    type: DEPLOYMENT_SETTING_LOAD_PROJECT_DEP_SETTING_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DEPLOYMENT_SETTING_LOAD_PROJECT_DEP_SETTING_BEGIN:
      return {
        ...state,
        loadProjectDepSettingPending: true,
        loadProjectDepSettingError: null,
      };

    case DEPLOYMENT_SETTING_LOAD_PROJECT_DEP_SETTING_SUCCESS:
      return {
        ...state,
        loadProjectDepSettingPending: false,
        loadProjectDepSettingError: null,
        projectDetail: action.data,
      };

    case DEPLOYMENT_SETTING_LOAD_PROJECT_DEP_SETTING_FAILURE:
      return {
        ...state,
        loadProjectDepSettingPending: false,
        loadProjectDepSettingError: action.data.error,
      };

    case DEPLOYMENT_SETTING_LOAD_PROJECT_DEP_SETTING_DISMISS_ERROR:
      return {
        ...state,
        loadProjectDepSettingError: null,
      };

    default:
      return state;
  }
}
